import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {
  AssayDevelopmentStudyState,
  StudySchema,
  TypedStudyAdapter,
} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverview from '../shared/MultiProcedureRunAndPlanOverview';
import MultiProcedureRunAndPlanOverviewTabContents from '../shared/MultiProcedureRunAndPlanOverviewTabContents';
import MultiProcedureRunOverview from '../shared/MultiProcedureRunOverview';
import MultiProcedureRunOverviewTabContents from '../shared/MultiProcedureRunOverviewTabContents';

export const ProcessDevelopmentStudyAdapter: TypedStudyAdapter<never, never, AssayDevelopmentStudyState> = {
  type: StudyType.PROCESS_DEVELOPMENT,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: true,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: true,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  modalOptions: (stepKey: never) => ({}),

  getButtonsByStep() {
    return null;
  },

  renderMetadataSection(state: AssayDevelopmentStudyState) {
    return <></>;
  },

  getSteps: () => [],

  renderStep(key: never) {},

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },
  creation: {
    async: false,
  },
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: BenchlingConfig.STUDIES_ENABLE_PROCEDURE_RUN_DESIGN
        ? MultiProcedureRunAndPlanOverviewTabContents
        : MultiProcedureRunOverviewTabContents,
      design: null,
      execution: BenchlingConfig.STUDIES_ENABLE_PROCEDURE_RUN_DESIGN
        ? MultiProcedureRunAndPlanOverview
        : MultiProcedureRunOverview,
    },
  },
  review: {},
};
